import { Text } from '@user-portal/wikr-components';

import { SidebarLinkButtonProps } from '../types';

import * as S from '../styled';

const SidebarLinkButton = ({ isActive, title, icon: Icon }: SidebarLinkButtonProps) => (
    <S.NavButton $isActive={isActive} data-testid="sidebar-link-button">
        {Icon && <Icon color="text-secondary" />}
        <Text type="medium-text" color="text-main">
            {title}
        </Text>
    </S.NavButton>
);

export default SidebarLinkButton;
